// Nom d'emprunt affiché à la place de l'identité d'un joueur quand une structure
// freemium consulte la liste ou une fiche. Un libellé unique donnait à toutes les
// lignes la même largeur, ce qui trahissait la donnée bouchon : on génère donc un
// couple adjectif + animal façon « docker run », dérivé de l'id du joueur. Stable
// d'un rendu à l'autre, de longueur très variable d'une ligne à l'autre, et
// impossible à confondre avec une identité réelle.
//
// Partagé client/serveur : la liste et la fiche détaillée doivent afficher le
// même nom d'emprunt pour un joueur donné.

// Longueurs volontairement étalées (3 à 13 caractères) pour que la censure ne
// produise pas des pavés de largeur uniforme.
const ADJECTIVES = [
  "Vif",
  "Calme",
  "Agile",
  "Tenace",
  "Discret",
  "Vaillant",
  "Lumineux",
  "Malicieux",
  "Intrépide",
  "Flamboyant",
  "Imperturbable",
];

const ANIMALS = [
  "Lynx",
  "Otarie",
  "Faucon",
  "Belette",
  "Albatros",
  "Hérisson",
  "Marmotte",
  "Bouquetin",
  "Salamandre",
  "Rhinocéros",
  "Chardonneret",
];

// FNV-1a 32 bits : suffisant pour répartir des uuid sur deux petits tableaux.
function hash(seed: string): number {
  let value = 0x811C9DC5;
  for (let i = 0; i < seed.length; i++) {
    value ^= seed.charCodeAt(i);
    value = Math.imul(value, 0x01000193);
  }
  return value >>> 0;
}

export function anonymousNameParts(seed: string): { firstName: string; lastName: string } {
  const seedHash = hash(seed);
  const firstName = ADJECTIVES[seedHash % ADJECTIVES.length];
  // Décalage de 5 bits pour que les deux mots ne soient pas corrélés.
  const lastName = ANIMALS[(seedHash >>> 5) % ANIMALS.length];

  return { firstName, lastName };
}

export function anonymousName(seed: string): string {
  const { firstName, lastName } = anonymousNameParts(seed);

  return `${firstName} ${lastName}`;
}
